
import { useState } from 'react';

/**
 * Hook for managing map visibility settings
 */
export const useMapVisibility = () => {
  // Initialize state with default values
  const [showDevices, setShowDevices] = useState<boolean>(true);
  const [showConsumers, setShowConsumers] = useState<boolean>(true);

  return {
    showDevices,
    showConsumers,
    setShowDevices,
    setShowConsumers
  };
};
